<template>

	<!-- content -->
	<div id="content" class="content find">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">비밀번호 찾기</h2>
				<p class="sub-tit">가입 시에 등록한 정보를 입력해 주세요.</p>
			</div>
			<form @submit.prevent="doSearch">
				<div class="find-form gui-form">
					<div class="row-box necessary">
						<label class="label" for="id">아이디</label>
						<div class="inp-set">
							<input id="id" name="id" type="text" placeholder="아이디" v-model="coEmailId">
						</div>
					</div>
					<div class="row-box">
						<label class="label" for="name">이름</label>
						<div class="inp-set">
							<input id="name" name="name" type="text" placeholder="이름" v-model="userName" required="required">
						</div>
					</div>
					<div class="row-box">
						<label class="label" for="phoneNo">휴대전화</label>
						<div class="inp-set">
							<input id="phoneNo2" name="phoneNo2" type="tel" placeholder="‘-’생략하고 입력" v-model="phoneNo" required="required">
						</div>
<!--						<div class="sel-inp-set">
							<select id="phoneNo" name="phoneNo">
								<option value="010">010</option>
								<option value="011">011</option>
								<option value="016">016</option>
								<option value="017">017</option>
								<option value="018">018</option>
								<option value="019">019</option>
							</select>
							<input id="phoneNo2" name="phoneNo2" type="text" placeholder="‘-’생략하고 입력">
						</div>-->
					</div>
				</div>
				<div class="btn-area">
					<button type="submit" class="btn-submit">비밀번호 찾기</button>
				</div>
			</form>
		</div>
	</div>
	<!--//content -->

</template>

<script>
export default {
	name: "findPasswd",
	data() {

		return {
			coEmailId: "",
			userName: "",
			phoneNo: "",
		}
	},
	created() {

	},
	methods: {


		doSearch (e) {

			e.preventDefault()

			const self = this
			this.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.CO_ACCOUNT + "/doFindPassword", {
				coEmailId: this.coEmailId,
				userName: this.userName,
				phoneNo: this.phoneNo,
			}, (res) => {
				this.$eventBus.$emit("doneProgress")

				const result = res.data;
				if (result.status === "ok") {
					const coEmailIdArr = result.coEmailId.split("@");
					const emailEnc = self.stringUtils.idFilter( coEmailIdArr[0] ) + "@" + coEmailIdArr[1];
					self.swalUtils.fire("비밀번호 초기화", "가입하신 이메일 " + emailEnc + "로 초기화된 이메일이 발송되었습니다.", "success")
						.then(() => {
							self.coEmailId = "";
							self.userName = "";
							self.phoneNo = "";
							location.href = "/";
						});
				} else {
					self.swalUtils.gritter(result.warnLevel == 1 ? "Info" : "Error", result.msg, result.warnLevel == 1 ? "info" : "error", 5000);
				}
			})


		}


	}
}
</script>

<style scoped>

</style>